import './Home.css';
import resume_file from './assets/resume.pdf';
import sing_airport from './assets/resume_bg.jpeg';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

function Resume() {
    return (
        <>
            <div className="resume-background" style={{ backgroundImage: `url(${sing_airport})` }}>
                <div className="resume-container">
                    <iframe src={resume_file} width="100%" height="600px" title="Resume PDF View">
                        This browser does not support PDFs. Please download the PDF to view it: <a href={resume_file}>Download PDF</a>.
                    </iframe>
                    <p className="backup-instructions">If the preview is invisible, <a href={resume_file} target="_blank" rel="noopener noreferrer">click here</a> to view</p>
                </div>
            </div>
        </>
    );
}

export default Resume;
